module.exports = __webpack_public_path__ + "static/media/9701a661bbc0f9d08661f28b2d670f9b.542f525b.jpg";